module.exports = __webpack_public_path__ + "static/img/notes-bg.eccdf5a4.png";